import React from 'react';
import api from '../../helpers/api';

import styles from './OpeningHours.module.scss';
import Loader from '../miscellaneous/Loader/Loader';
import MultiSelect from '../miscellaneous/MultiSelect/MultiSelect';
import Tooltip from '../miscellaneous/Tooltip/Tooltip';

import {FiInfo} from 'react-icons/fi';
import {$t} from '../../helpers/translator';
import _ from "lodash";
import {connect} from "react-redux";
import {getUserClinic} from "../../store/auth-slice";
import {setAlert} from "../../store/alerts-slice";


class OpeningHours extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workingHours: null,
            total: 0,
        };
    }

    async componentDidMount() {
        await this.getClinicData();
    }

    async getClinicData(force = false) {
        if (!this.props.state.auth.accountData) {
            await this.props.dispatch(getUserClinic(force));
        }
        let accountData = this.props.state.auth.clinic;

        let workingHours = [
            {
                label: $t('global.dateTime.sunday'),
                variableName: 'sunday', //name of variable in DB
            }, {
                label: $t('global.dateTime.monday'),
                variableName: 'monday',
            }, {
                label: $t('global.dateTime.tuesday'),
                variableName: 'tuesday',
            }, {
                label: $t('global.dateTime.wednesday'),
                variableName: 'wensday',    //error is in back, do not change.
            }, {
                label: $t('global.dateTime.thursday'),
                variableName: 'thursday',
            }, {
                label: $t('global.dateTime.friday'),
                variableName: 'friday',
            }, {
                label: $t('global.dateTime.saturday'),
                variableName: 'saturday',
            },
        ];

        let total = 0;

        _.forEach(workingHours, (v) => {
            if (!accountData || !accountData[v.variableName + '_open'] || !accountData[v.variableName + '_open'] || !accountData[v.variableName + '_open']) {
                return;
            }
            v.open = accountData[v.variableName + '_open'];
            v.close = accountData[v.variableName + '_close'];
            v.total = accountData[v.variableName + '_hrs'];
            total += v.total;
        });

        this.setState({
            workingHours: workingHours,
            total: total
        });
    }

    min2str(minutes) {
        let hour = Math.floor(minutes / 60).toString();
        let min = (minutes % 60).toString().length === 1 ? '0' + (minutes % 60).toString() : (minutes % 60).toString();
        return hour + ':' + min;
    }

    str2min(str) {
        if (!str) {
            str = '0:00';
        }

        let hour = str.split(':')[0];
        let min = str.split(':')[1];
        return parseInt(hour) * 60 + parseInt(min);
    }

    hourChangeHandler(dayId, type, data) {
        let workingHours = this.state.workingHours;
        workingHours[dayId][type] = data.value;

        if (this.str2min(workingHours[dayId]['open']) > this.str2min(workingHours[dayId]['close'])) {
            // console.log(this.str2min(workingHours[dayId]['open']), this.str2min(workingHours[dayId]['close']), 'err');
            //opening hours are negative

            let newTimes = this.autofixOpeningHours(workingHours[dayId]['open'], workingHours[dayId]['close'], type);
            // console.log(newTimes);

            workingHours[dayId]['open'] = newTimes.open;
            workingHours[dayId]['close'] = newTimes.close;
        }

        workingHours[dayId]['total'] = (this.str2min(workingHours[dayId]['close']) - this.str2min(workingHours[dayId]['open'])) / 60;

        this.setState({workingHours: workingHours}, async () => {
            // console.log('>>>>',this.state);
            await this.postOpeningHours();
        });
    }

    async postOpeningHours() {
        let payload = {};
        let totalWeeklyHours = 0;

        _.forEach(this.state.workingHours, (v) => {
            payload[`${v.variableName}_open`] = v.open;
            payload[`${v.variableName}_close`] = v.close;
            payload[`${v.variableName}_hrs`] = v.total;
            totalWeeklyHours += v.total;
        });
        payload.weekly_hours = totalWeeklyHours;

        try {
            let res = await api.post('/account/update/clinic/hrs', payload);

            if (res && res.data && res.data.success) {
                let workingHours = {...this.state.workingHours}
                let total = 0;
                _.forEach(workingHours, (v) => {
                    total += v.total;
                })
                this.setState({total: total}, async () => {
                    // this.props.dispatch(getUserClinic(true));
                    await this.getClinicData(true);
                    this.props.dispatch(setAlert({type: 'success'}));
                })
                return;
            }
            this.props.dispatch(setAlert({type: 'error'}));
        } catch (e) {
            console.error('time update err', e);
            this.props.dispatch(setAlert({type: 'error'}));
        }
    }

    autofixOpeningHours(open, close, changedHour) {
        let baseDayLength = 6; //hours

        let openMin = this.str2min(open);
        let closeMin = this.str2min(close);

        let newOpen = openMin;
        let newClose = closeMin;

        // return null
        switch (changedHour) {
            case 'open':
                //modifying close:
                newClose = openMin + (baseDayLength * 60);
                while (newClose > 1440 && newClose >= openMin) {
                    newClose -= 30;
                }
                break;
            case 'close':
                //modifying open:
                newOpen = closeMin - (baseDayLength * 60);
                while (newOpen < 0 && newOpen <= closeMin) {
                    newOpen += 30;
                }
                break;
            default:
        }

        return {
            open: this.min2str(newOpen),
            close: this.min2str(newClose)
        };
    }

    renderWorkingHours() {
        let hourOptions = [];
        for (let i = 0; i <= 24 * 60; i = i + 30) {
            hourOptions.push({
                value: this.min2str(i),
                label: this.min2str(i),
            });
        }

        return (
            <div>
                {this.state.workingHours.map((v, k) => (
                    <div className={`${styles['day-row']}`} key={k}>
                        <div className={`${styles['day-container']}`}>{v.label}</div>

                        <div className={`${styles['times-container']}`}>
                            <div className={`${styles['time-container']}`}>
                                <MultiSelect
                                    selected={{
                                        value: v.open,
                                        label: v.open,
                                    }}
                                    options={hourOptions}
                                    onValueChange={(data) => this.hourChangeHandler(k, 'open', data)}
                                />
                            </div>
                            <div className={`${styles['time-container']}`}>
                                <MultiSelect selected={{
                                    value: v.close,
                                    label: v.close,
                                }} options={hourOptions}
                                             onValueChange={(data) => this.hourChangeHandler(k, 'close', data)}
                                />
                            </div>
                        </div>

                        <div className={`${styles['total-time-container']}`}>
                            <div>
                                {v.total > 0 ? v.total + ' ' + $t('global.dateTime.hours') : $t('global.account.closed')}
                            </div>
                        </div>
                    </div>
                ))}
                <div className={`${styles['day-row']}`}>
                    <div className={`${styles['day-container']}`}></div>
                    <div className={`${styles['times-container']}`}></div>
                    <div className={`${styles['total-time-container']}`}>
                        <div style={{
                            fontSize: '18px',
                            fontWeight: '600'
                        }}>{$t('global.account.weeklyHours')}: {this.state.total} {$t('global.dateTime.hours')}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id="openingHours">
                <div className={`alma-box ${styles['container']}`}>
                    <div className={`alma-box-header ${styles['alma-box-header']}`}>
                        <span><h3>{$t('global.account.openingHours')}</h3></span>
                        <Tooltip
                            content={$t('global.account.openingHoursTooltipText')}>
                            <FiInfo className={`${styles['info-icon']}`}/>
                        </Tooltip>
                    </div>
                    {this.state.workingHours ?
                        this.renderWorkingHours()
                        :
                        <Loader/>
                    }
                </div>
            </div>
        );
    }
}

// export default ClinicOpeningHours;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(OpeningHours);
